import GlobalProgressBar from './ProgressBar';

export default GlobalProgressBar;
